import script from "./TelephonyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TelephonyPage.vue?vue&type=script&setup=true&lang=js"

import "./TelephonyPage.vue?vue&type=style&index=0&id=5d2a348b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2a348b"]])

export default __exports__